(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jump-links"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Collect all sections that should appear in the jump links navigation
    let sectionElements = document.querySelectorAll('[data-jump-link-item]');
    if (!sectionElements.length) {
      return;
    }

    // Moves jump link markers from their original elements to the following
    // Shopify section, ensuring the jump link target aligns with the actual
    // rendered section boundary instead of an internal placeholder element
    sectionElements.forEach((element) => {
      const jumpLinkItem = element.dataset.jumpLinkItem;
      const section = element.closest('.shopify-section');
      const siblingSection = section.nextElementSibling;

      if (siblingSection) {
        siblingSection.dataset.jumpLinkItem = jumpLinkItem;
        section.remove();
      }
    });
    sectionElements = document.querySelectorAll('[data-jump-link-item]');

    // Normalize NodeList to array and extract section titles
    const sectionElementArray = [...sectionElements];
    const sectionTitles = sectionElementArray.map(
      (element) => element.dataset.jumpLinkItem
    );

    // Cache commonly used DOM elements
    const jumpLinksWrapper = document.querySelector('.jump-links');
    const jumpLinksNav = document.querySelector('[data-jump-links-nav]');
    const productContent = document.querySelector('.product__main');
    const template = document.getElementById('jump-link-item-template');

    if (!jumpLinksWrapper || !jumpLinksNav || !productContent) {
      return;
    }

    const announcementBar = document.querySelector('.announcement-bar');

    // Disable sticky header behavior while jump links are active
    document.dispatchEvent(new CustomEvent('disable-sticky-header'));

    // Flag to prevent intersection updates during manual navigation
    let userSelectedItem = false;
    let userSelectedTimeout;

    // Smoothly scrolls the page to a selected section
    const goToItem = (title) => {
      const activeItem = document.querySelector(
        `[data-jump-link-item="${title}"]`
      );

      if (!activeItem) {
        return;
      }

      // Temporarily disable intersection-based updates
      userSelectedItem = true;
      clearTimeout(userSelectedTimeout);
      userSelectedTimeout = setTimeout(() => {
        userSelectedItem = false;
      }, 1000);

      const extraOffset = 32;
      const announcementBarHeight = announcementBar
        ? announcementBar.offsetHeight
        : 0;

      // Scroll to section, accounting for jump links height
      window.scrollTo({
        top:
          activeItem.offsetParent.offsetTop +
          activeItem.offsetTop -
          jumpLinksNav.offsetHeight -
          announcementBarHeight -
          extraOffset,
        behavior: 'smooth'
      });
    };

    // Updates the active menu item and optionally triggers scrolling
    const setActiveItem = (title, actionType) => {
      const menuItemElements =
        jumpLinksWrapper.querySelectorAll('[data-active]');
      const menuItems = Array.from(menuItemElements);
      const activeItem = menuItems.find(
        (item) => item.dataset.jumpLinkTitle === title
      );

      // Reset all items to inactive
      menuItems.forEach((item) => {
        item.setAttribute('data-active', 'false');
      });

      // Mark selected item as active
      activeItem.setAttribute('data-active', 'true');

      // Scroll navigation container to keep active item in view
      const containerRect = jumpLinksNav.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();
      jumpLinksNav.scrollTo({
        left: jumpLinksNav.scrollLeft + (itemRect.left - containerRect.left),
        behavior: 'smooth'
      });

      // Only scroll the page when triggered by a click
      if (actionType === 'click') {
        goToItem(title);
      }
    };

    // Handles section visibility changes for updating active state
    const handleJumpLinksNavIntersection = (entries) => {
      entries.forEach((entry) => {
        // Ignore intersection updates during manual scrolling
        if (userSelectedItem) {
          return;
        }

        // Update active menu item when a section becomes visible
        if (entry.isIntersecting) {
          const element = entry.target;
          const activeTitle = element.dataset.jumpLinkItem;
          setActiveItem(activeTitle, 'scroll');
        }
      });
    };

    // Observe section visibility relative to viewport
    const observer = new IntersectionObserver(handleJumpLinksNavIntersection, {
      root: null,
      threshold: 0.15,
      rootMargin: `0px 0px -${announcementBar ? announcementBar.offsetHeight : 0}px 0px` // adjust for sticky headers
    });

    // Attach observer to all sections and main product section
    sectionElementArray.forEach((element) => {
      observer.observe(element);
    });

    // Observes the main PDP section to control jump links bar visibility
    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        const { isIntersecting, boundingClientRect } = entry;

        // True when the top of the PDP main section has scrolled above the viewport
        const scrolledPastTop = boundingClientRect.top < 0;

        if (!isIntersecting && scrolledPastTop) {
          // Show jump links only after the PDP main section
          // has been scrolled past and is no longer visible
          jumpLinksWrapper.classList.remove('jump-links--inactive');
        } else {
          // Hide jump links when above the PDP section
          // or while it is still visible in the viewport
          jumpLinksWrapper.classList.add('jump-links--inactive');
        }
      },
      {
        threshold: 0.25
      }
    );
    visibilityObserver.observe(productContent);

    // Adjust jump links offset when announcement bar height changes
    const resizeObserver = new ResizeObserver(() => {
      jumpLinksWrapper.style.setProperty(
        '--top-offset',
        announcementBar ? `${announcementBar.offsetHeight}px` : '0px'
      );
    });

    if (announcementBar) {
      resizeObserver.observe(announcementBar);
    }

    // Build jump link buttons from template and attach click handlers
    sectionTitles.forEach((title, index) => {
      const clone = template.content.cloneNode(true);
      const element = clone.querySelector('button');

      // Default first item to active
      if (index === 0) {
        element.setAttribute('data-active', 'true');
      }

      element.textContent = title;
      element.dataset.jumpLinkTitle = title;
      element.onclick = () => setActiveItem(title, 'click');

      jumpLinksNav.appendChild(clone);
    });

    // Remove template from DOM once menu is built
    template.remove();
  });

  } catch(e) { console.error(e); }
})();
})();
